'use client';

import { AUTH_EVENTS } from '@repo/analytics';
import { signOut } from '@repo/auth';
import { useRouter } from 'next/navigation';
import { useCallback } from 'react';
import { trackEvent } from '@/lib/analytics';

export function useSignOut(): () => Promise<void> {
  const router = useRouter();

  const handleSignOut = useCallback(async (): Promise<void> => {
    trackEvent(AUTH_EVENTS.signOut);
    await signOut({
      fetchOptions: {
        onSuccess: () => {
          router.push('/login');
        },
      },
    });
  }, [router]);

  return handleSignOut;
}
